import React from 'react';
import './ContextMenu.scss';
import Markdown from 'react-markdown';
import { ChoseFigure } from '../../services/WebSocketService/types/ChoseFigure';

export interface ContextButtonData {
  buttonText: string;
  contextActionCallback: () => void;
}

export interface ContextMenuProps {
  choseFigurePos: ChoseFigure | null;
  setChoseFigurePos: (arg0: ChoseFigure | null) => void;
}

const ContextMenu: React.FC<ContextMenuProps> = ({ choseFigurePos, setChoseFigurePos }) => {

  let textContent;
  let contextButtonData;
  if (choseFigurePos) {
    const piece_info = choseFigurePos.pieceInfo;
    textContent = `# ${piece_info.name}\n*${piece_info.tagline}* \n\n${piece_info.description}`

    if (choseFigurePos.contextActions){
      contextButtonData = choseFigurePos.contextActions.map((item: any, index: any) => ({
        buttonText: item.context_button_name,
        contextActionCallback: () => {}
        //handle_context_action_button(item, {figure: figure, availableCells: combinedPositionMap, actionCells: actionCells, contextAction: context_actions[0]})}
      }));
    }
    
  }
  

  const markdown = '# Welcome to the Context Menu!\n\n\n\n\n Click on a piece to view its details and available actions. Explore your options and make strategic moves!';

  return (
    <div className="context-menu">
      <div className="content">
        {textContent ? (
          <Markdown>{textContent}</Markdown>
        ) : (
          <Markdown>{markdown}</Markdown>
        )}
      </div>

      {contextButtonData && (
        <div className="button-container">
          {contextButtonData.map((buttonData, index) => (
            <button
              key={index}
              onClick={() => {
                if (choseFigurePos) {
                  setChoseFigurePos({
                    ...choseFigurePos,
                    contextActionActive: choseFigurePos.contextActionActive === -1 ? index : -1,
                  })
                }
              }}
              className={`context-button ${choseFigurePos?.contextActionActive !== -1 ? "glowing" : ""}`}
            >
              
              {buttonData.buttonText || "Button"}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContextMenu;
